import { allCatalog } from '../data/catalog';

const STORAGE_KEY = 'designforge:saved:v1';
const catalogIds = new Set(allCatalog.map(item => item.id));
// Managed resources load asynchronously; keep their stable IDs until the public catalog arrives.
const managedResourceId = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function readSaved(): string[] {
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    return Array.isArray(parsed) && parsed.every(value => typeof value === 'string')
      ? [...new Set(parsed.filter(id => catalogIds.has(id) || managedResourceId.test(id)))] : [];
  } catch { return []; }
}

export function writeSaved(ids: string[]) {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(ids)); } catch { /* in-memory state remains useful */ }
}
